import {TravelGuideBanner} from 'components/TravelGuideBanner';
import {useSummary} from 'context/summary';
import {usePath} from 'hooks';
import {useAnalytics, POSTHOG_EVENTS} from 'analytics';
import {PATHS} from 'routes/constants';
import {isTravelGuideEnabled} from 'utils/travelGuide';

export function TravelGuidePromoBanner() {
  const {data: summary} = useSummary();
  const {getFullPath} = usePath();
  const {track} = useAnalytics();

  const isActive =
    isTravelGuideEnabled(summary?.country_code) && Boolean(summary?.upselling?.active);

  if (!isActive) return null;

  return (
    <TravelGuideBanner
      to={getFullPath(PATHS.travelGuide)}
      onClick={() =>
        track(POSTHOG_EVENTS.TRAVEL_GUIDE_BANNER_CLICKED, {source: 'home_banner'})
      }
    />
  );
}
